import useToaster from './useToaster';

export default useToaster;
